import { useEffect, useState } from 'react';

/**
 * Hook per controllare l'autenticazione basata su cookie Supabase SSO
 * Controlla il cookie "nexallai_sso_session" condiviso tra i sottodomini
 * Estrae il nome utente dal cookie JWT
 */
/**
 * Legge un cookie dal browser
 */
export const getCookie = (name) => {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
};

/**
 * Decodifica un JWT per estrarre i dati dell'utente
 * Nota: Questo non verifica la firma, solo decodifica il payload
 */
export const decodeJWT = (token) => {
  try {
    // JWT ha 3 parti separate da punti
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    // Decodifica la parte payload (seconda parte)
    const payload = parts[1];
    // Aggiungi padding se necessario
    const padded = payload + '='.repeat((4 - payload.length % 4) % 4);
    const decoded = atob(padded);
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Errore decodifica JWT:', error);
    return null;
  }
};

/**
 * Estrae il nome utente dal cookie SSO
 * Restituisce sempre in minuscolo per case-insensitivity
 */
export const extractUsernameFromCookie = (sessionCookie) => {
  if (!sessionCookie) return null;

  try {
    let parsed = null;
    try {
      const decodedUri = decodeURIComponent(sessionCookie);
      parsed = JSON.parse(decodedUri);
      const email = parsed.user?.email || parsed.email;
      if (email) return email.toLowerCase();
    } catch (e) {
      // Non è un JSON semplice o non contiene email, procedi con JWT
    }

    // 2. Prova a decodificare il JWT (se JSON, usa l'access_token interno)
    const tokenToDecode = parsed?.access_token || sessionCookie;
    const decoded = decodeJWT(tokenToDecode);

    if (decoded) {
      const name = decoded.email || decoded.username || decoded.user?.email || decoded.sub || null;
      if (name) return name.toLowerCase();
    }

    return null;
  } catch (error) {
    console.error('Errore estrazione username dal cookie:', error);
    return null;
  }
};

/**
 * Hook per controllare l'autenticazione basata su cookie Supabase SSO
 * Controlla il cookie "nexallai_sso_session" condiviso tra i sottodomini
 * Estrae il nome utente dal cookie JWT
 */
export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [username, setUsername] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = () => {
    try {
      // Controlla se il cookie di Supabase SSO esiste
      const sessionCookie = getCookie('nexallai_sso_session');

      if (sessionCookie) {
        setIsAuthenticated(true);

        // Estrai il nome utente dal cookie
        const extractedUsername = extractUsernameFromCookie(sessionCookie);

        setUser({
          session: sessionCookie,
          username: extractedUsername
        });
        setUsername(extractedUsername);

        console.log('✅ Utente autenticato:', extractedUsername);
      } else {
        // Se non autenticato, reindirizza alla pagina di login
        setIsAuthenticated(false);
        setUsername(null);
        redirectToLogin();
      }
    } catch (error) {
      console.error('Errore nel controllo autenticazione:', error);
      setIsAuthenticated(false);
      setUsername(null);
      redirectToLogin();
    } finally {
      setLoading(false);
    }
  };

  const redirectToLogin = () => {
    // Reindirizza al login Supabase SSO
    window.location.href = 'https://demo.nexallai.com/login';
  };

  return {
    isAuthenticated,
    loading,
    user,
    username,
    redirectToLogin,
    checkAuth
  };
};
